import { createReducer, on } from '@ngrx/store';

import { IListMessagesByRoomResult } from '@shared/models/messages';

import {
  resetMessagesAction,
  listMessagesByRoomAction,
  listMessagesByRoomActionSuccess,
  listMessagesByRoomActionFailure,
} from './messages.actions';

export interface MessagesState {
  messages: {
    loading: boolean;
    errors: boolean;
    pageOfMessages?: IListMessagesByRoomResult['listMessagesByRoom'];
  };
}

export const initialState: MessagesState = {
  messages: {
    loading: false,
    errors: false,
    pageOfMessages: undefined,
  },
};

export const messagesReducer = createReducer(
  initialState,
  on(resetMessagesAction, () => ({ ...initialState })),

  on(listMessagesByRoomAction, (state) => ({
    ...state,
    messages: {
      ...state.messages,
      loading: true,
    },
  })),

  on(listMessagesByRoomActionSuccess, (state, action) => ({
    ...state,
    messages: {
      ...state.messages,
      loading: false,
      errors: false,
      pageOfMessages: action.listMessagesByRoom,
    },
  })),
  on(listMessagesByRoomActionFailure, (state) => ({
    ...state,
    messages: {
      ...state.messages,
      loading: false,
      errors: true,
    },
  }))
);
